//import 'jquery-clickout';
import 'clickout-event';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'info_icon';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
		this.$trigger 		= 	this.$el.find( '.trigger-icon' );
		this.toggleClass    =   this.options.toggleClass?this.options.toggleClass:'is-open';
		this.$win   		= 	this.$el.find('.info-window');

		this.init();
    }

    init(){
    	this.addEvents( true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$trigger.on( 'click', () => this.onChange() );
			this.$win.find( '.close' ).on( 'click', () => this.onChange() );
			this.$win.on( 'clickout', (e)=>this.onClickOut(e) );

		}
		else{
			this.$trigger.off( 'click', () => this.onChange(e) );
			this.$win.find( '.close' ).off( 'click', () => this.onChange() );
			this.$win.off( 'clickout', (e)=>this.onClickOut(e) );
		}
	}

	onClickOut(e){
		if ( this.$el.hasClass( 'is-open' ) ){
			this.onChange();
		}
	}

	onChange(){
		this.$el.toggleClass( this.toggleClass );
		if ( this.$el.hasClass( 'is-open' ) ){

			// attach to main to be on top
			$('main').append( this.$win );
			this.$win.css({
				opacity: 1,
				'pointer-events': 'auto'
			});
			this.setWindowPosition();
		}
		else{
			this.$el.append( this.$win );
			this.$win.css({
				opacity: 0,
				'pointer-events': 'none'
			});
		}
 	}

 	setWindowPosition(){
 		let w = $(window).width(), 
 			h = $(window).height(),
 			x = this.$el.offset().left, 
 			y = this.$el.offset().top; // - $('main').offset().top + this.$trigger.height()/2; // - $(window).scrollTop() - this.$trigger.height();

 		x += 40;
 		y -= this.$win.outerHeight()/2;

 		x = Math.max(0,Math.min(x,w-this.$win.outerWidth()));

 		//y = Math.max(0,Math.min(y,h-this.$win.outerHeight()));

 		this.$win.css({
 			left: x,
 			top: y
 		})
 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.addEvents( false );
    }

}


